<template>
	<div>
		<v-data-table hide-headers disable-initial-sort :headers="headers" :items="categories" hide-actions class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-left">{{ props.item.text }}</td>
					<td class="justify-center px-0">
						<v-icon small class="mr-2" @click="editCategory(props.item)">
							edit
						</v-icon>
						<v-icon small @click="deleteCategory(props.item)">
							delete
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import CategoryEditor from '@/components/CategoryEditor';

	export default {
		components: {
			CategoryEditor
		},
		props: {
			categories: {
				required: true,
				type: Array
			}
		},
		data() {
			return {
				headers: [
					{ text: 'Text', value: 'text' },
					{ text: '', value: 'actions', sortable: false }
				]
			};
		},
		methods: {
			editCategory(item) {
				this.$emit('onEditCategory', item);
			},
			deleteCategory(item) {
				this.$emit('onDeleteCategory', item);
			}
		}
	};
</script>

<style></style>
